import React, { FC, useState, useEffect, useCallback } from 'react';
import { Prompt, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isMobileSafari } from 'react-device-detect';
import { TerminateRun } from './TerminateRun';
import { TerminateRefund } from './TerminateRefund';
import { TerminateDetails } from './TerminateDetails';
import { TerminateTransfer } from './TerminateTransfer';
import { ITerminationStep, ITerminateForm } from '../../../models/ContractTermination';

interface TerminateContractProps {
  step: ITerminationStep;
  setStep: (step: ITerminationStep) => void;
}

const initialFormState: ITerminateForm = {
  phone: '',
  isIAgree: false,
  name: '',
  itn: 0,
  iban: '',
  contractNumber: 0,
  isDirty: false,
};

export const TerminateContract: FC<TerminateContractProps> = ({ step, setStep }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [formState, setFormState] = useState<ITerminateForm>(initialFormState);

  const beforeUnloadHandler = useCallback((event: BeforeUnloadEvent) => {
    event.preventDefault();

    const eventObj = event;
    eventObj.returnValue = true;
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadHandler);
    };
  }, []);

  useEffect(() => {
    if (isMobileSafari || !formState.isDirty) {
      window.removeEventListener('beforeunload', beforeUnloadHandler);
      return;
    }
    window.addEventListener('beforeunload', beforeUnloadHandler);
  }, [formState.isDirty, beforeUnloadHandler]);

  return (
    <>
      {!isMobileSafari && formState.isDirty && (
        <Prompt
          message={(loc) => {
            return loc.pathname === pathname || (t('terminateContract.dataLoss') as string);
          }}
        />
      )}
      <h3 className="bold">{t('terminateContract.launch')}</h3>
      {step === 'run' && (
        <TerminateRun formState={formState} setFormState={setFormState} changeTerminateStep={setStep} />
      )}
      {step === 'refund' && (
        <TerminateRefund formState={formState} setFormState={setFormState} changeTerminateStep={setStep} />
      )}
      {step === 'details' && <TerminateDetails formState={formState} changeTerminateStep={setStep} />}
      {step === 'transfer' && <TerminateTransfer formState={formState} changeTerminateStep={setStep} />}
    </>
  );
};
